import React from 'react';

import { Filter } from '@pkg/classes';
import { FilterChip } from '@pkg/components/filters';
import { truncateContractAddress } from '@pkg/utils';

import { useNFTsFiltersStore } from '@app/store/zustand';

export interface AppliedChipProps {
    filterKey: string;
}

export function AppliedChip({ filterKey }: AppliedChipProps) {
    const { currentFilters, setCurrentFilters } = useNFTsFiltersStore();
    const label = filterKey.startsWith('0x') ? truncateContractAddress(filterKey) : filterKey;

    function clearFilter() {
        const updatedFilters = new Filter(currentFilters);
        // Keep the filter key entry, but remove all values.
        updatedFilters.set(filterKey, []);

        setCurrentFilters(updatedFilters);
    }

    return (
        <FilterChip
            label={label}
            ariaLabel={`Click to remove ${filterKey} filter`}
            variant="dismiss"
            onAction={clearFilter}
        />
    );
}
